<ot-navbar [navbar]="navbar"></ot-navbar>
<section class="main-container">
  <router-outlet></router-outlet>
</section>
<ot-footer-component></ot-footer-component>
<ot-notification></ot-notification>
<ot-walkme-container [appName]="applicationName"></ot-walkme-container>
